import { useAppDispatch } from 'src/reducers';
import { closeModal } from 'src/reducers/modal.reducer';
import styles from './modal.module.scss';

const ModalBackdrop = () => {
  const dispatch = useAppDispatch();

  return <div className={styles.backDrop} onClick={() => dispatch(closeModal())} />;
};

export default ModalBackdrop;

ModalBackdrop.displayName = 'Modal.Backdrop';
